import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "legal-letters-and-statements"
    }}>{`Legal Letters and Statements`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Legal firms and teams produce countless legal letters and statements for their clients. Drafting, client review, and signing take time — especially when done manually. The current process requires personally customizing templates with specific client information and then sending for review and signature. It’s repetitive and time consuming, and automation frees up valuable time. Adobe Acrobat Services allows legal firms to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard legal letter templates readily`}</li>
      <li parentName="ul">{`Merge specific client data from any business system in a few clicks`}</li>
      <li parentName="ul">{`Automatically send letters for client review and signature`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A legal team creates affidavits of identity frequently for clients, often on tight deadlines. The team needs to quickly generate letters based on the client's personal data stored in their system, and automation ensures accuracy, helps the team meet deadlines, and gives the team back valuable time.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the legal letter template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final legal letter in PDF`}</li>
      <li parentName="ol">{`Send to Adobe Acrobat Sign if signatures are required, and if not, email directly`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      